import { render, staticRenderFns } from "./VacancyStepAiQuestions.vue?vue&type=template&id=31676de8&scoped=true&"
import script from "./VacancyStepAiQuestions.vue?vue&type=script&lang=js&"
export * from "./VacancyStepAiQuestions.vue?vue&type=script&lang=js&"
import style0 from "./VacancyStepAiQuestions.vue?vue&type=style&index=0&id=31676de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31676de8",
  null
  
)

/* custom blocks */
import block0 from "./VacancyStepAiQuestions.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyStepAiQuestions.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})
